import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { useMaterialUIController } from "context";
import { getEmployees } from "network/service";
import EmployeesTableData from "./data";
import AddEditEmployee from "./components/addEditEmployee";

export default function Employees() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [employeePopup, setEmployeePopup] = useState({ open: false, details: null });
  const [employees, setEmployees] = useState([]);
  const { formEmployeeRows, employeeHeaders } = EmployeesTableData();

  const fetchEmployees = () => {
    getEmployees()
      .then((resp) => {
        setEmployees(resp.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        {employeePopup.open && (
          <AddEditEmployee
            isopen={employeePopup.open}
            details={employeePopup.details}
            handleclose={() => {
              setEmployeePopup({ open: false, details: null });
            }}
            handlesuccess={() => {
              fetchEmployees();
              setEmployeePopup({ open: false, details: null });
            }}
          />
        )}
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card sx={{ height: "100%" }}>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Employees
                </MDTypography>
              </MDBox>
              <Stack direction="row-reverse" justifyContent="flex-start" alignItems="center" spacing={2}>
                <MDBox pt={3} pr={3}>
                  <MDButton
                    variant="outlined"
                    color="success"
                    onClick={() => {
                      setEmployeePopup({ open: true, details: null });
                    }}
                  >
                    Add Employee
                  </MDButton>
                </MDBox>
              </Stack>
              <MDBox sx={{ maxHeight: "100vh", overflow: "auto" }}>
                <DataTable
                  entriesPerPage={{ defaultValue: 10, entries: [5, 10, 20] }}
                  table={{
                    columns: employeeHeaders,
                    rows: formEmployeeRows(employees, (details) => setEmployeePopup({ open: true, details })),
                  }}
                  noEndBorder
                  canSearch
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
